import { lazy } from 'react';

const ConfigureMeetingSettingModal = lazy(() =>
  import('./modals/ConfigureMeetingSettingModal'),
);
const MeetingAvailabilityModal = lazy(() =>
  import('./modals/MeetingAvailabilityModal'),
);
const ScheduleMeetingModal = lazy(() =>
  import('./modals/ScheduleMeetingModal'),
);

export default {
  CONFIGURE_MEETING_SETTING_MODAL: ConfigureMeetingSettingModal,
  MEETING_AVAILABILITY_MODAL: MeetingAvailabilityModal,
  SCHEDULE_MEETING_MODAL: ScheduleMeetingModal,
};
